import React, { useEffect, useRef } from "react";
import { OFlowModel } from "../model";
export const useOFlowConfig = (fn) => {
    const oFlowIdRef = useRef();
    useEffect(() => {
        return () => {
            OFlowModel.destroyModel(oFlowIdRef.current);
        };
    }, []);
    return (oFlowId) => {
        oFlowIdRef.current = oFlowId;
        const model = OFlowModel.getModel(oFlowId);
        fn(model);
    };
};
export const OFlowContext = React.createContext({ oFlowId: '' });
//# sourceMappingURL=context.js.map